export default function initHomeSliderCaptions() {
  var slider = document.querySelector('.page-home-page .home-hero #n2-ss-2');

  if (!slider || slider.querySelector('.home-slider-caption-control')) {
    return;
  }

  var control = document.createElement('div');
  control.className = 'home-slider-caption-control home-slider-caption-control--empty';

  var caption = document.createElement('div');
  caption.className = 'home-slider-caption';

  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'home-slider-caption-control__toggle';
  button.setAttribute('aria-expanded', 'false');
  button.setAttribute('aria-label', 'Show image caption');
  button.innerHTML = '<span class="home-slider-caption-control__icon" aria-hidden="true"></span>';

  control.appendChild(caption);
  control.appendChild(button);
  slider.appendChild(control);

  function sanitizeCaption(html) {
    var template = document.createElement('template');
    template.innerHTML = html;

    template.content.querySelectorAll('script, style, iframe, object, embed').forEach(function(element) {
      element.remove();
    });

    template.content.querySelectorAll('*').forEach(function(element) {
      Array.prototype.slice.call(element.attributes).forEach(function(attribute) {
        var name = attribute.name.toLowerCase();
        var value = attribute.value.trim().toLowerCase();

        if (name.indexOf('on') === 0 || value.indexOf('javascript:') === 0) {
          element.removeAttribute(attribute.name);
        }
      });
    });

    return template.innerHTML.trim();
  }

  function getActiveSlide() {
    return slider.querySelector('.n2-ss-slide-active')
      || slider.querySelector('.n2-ss-slide:not([aria-hidden="true"])')
      || slider.querySelector('.n2-ss-slide[data-title]');
  }

  function updateCaption() {
    var activeSlide = getActiveSlide();
    var title = activeSlide ? activeSlide.getAttribute('data-title') || '' : '';
    var cleanTitle = sanitizeCaption(title);

    caption.innerHTML = cleanTitle;
    control.classList.toggle('home-slider-caption-control--empty', cleanTitle.length === 0);
  }

  updateCaption();

  function setCaptionVisible(isVisible) {
    control.classList.toggle('is-caption-visible', isVisible);
    button.setAttribute('aria-expanded', isVisible ? 'true' : 'false');
    button.setAttribute('aria-label', isVisible ? 'Hide image caption' : 'Show image caption');
  }

  slider.addEventListener('CurrentSlideChanged', updateCaption);
  slider.addEventListener('mainAnimationComplete', updateCaption);
  slider.addEventListener('BeforeShow', updateCaption);
  control.addEventListener('mouseenter', function() {
    setCaptionVisible(true);
  });
  control.addEventListener('mouseleave', function() {
    setCaptionVisible(false);
  });
  control.addEventListener('focusin', function() {
    setCaptionVisible(true);
  });
  control.addEventListener('focusout', function() {
    setCaptionVisible(false);
  });
  button.addEventListener('click', function() {
    setCaptionVisible(!control.classList.contains('is-caption-visible'));
  });

  var observer = new MutationObserver(updateCaption);
  slider.querySelectorAll('.n2-ss-slide').forEach(function(slide) {
    observer.observe(slide, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden']
    });
  });
}
